export const AUTH_CALLBACK_T_KEYS = {
  logLabel: "authCallback.logLabel",
  unknownErrorCode: "authCallback.unknownErrorCode",
  referenceCode: "authCallback.referenceCode",
  supportId: "authCallback.supportId",
  tryAgain: "authCallback.tryAgain",
  logoAlt: {
    wordmark: "authCallback.logoAlt.wordmark",
    bear: "authCallback.logoAlt.bear",
  },
  messages: {
    emailVerification: "authCallback.messages.emailVerification",
    passwordRotation: "authCallback.messages.passwordRotation",
    notEntitled: "authCallback.messages.notEntitled",
    orgDisabled: "authCallback.messages.orgDisabled",
    blockedUser: "authCallback.messages.blockedUser",
    invalidInvitation: "authCallback.messages.invalidInvitation",
    expiredInvitation: "authCallback.messages.expiredInvitation",
    invitationAlreadyUsed: "authCallback.messages.invitationAlreadyUsed",
    generic: "authCallback.messages.generic",
  },
  recovery: {
    emailVerification: "authCallback.recovery.emailVerification",
    passwordRotation: "authCallback.recovery.passwordRotation",
    unauthorized: "authCallback.recovery.unauthorized",
    invitationRetry: "authCallback.recovery.invitationRetry",
    generic: "authCallback.recovery.generic",
  },
} as const;
